var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"list":_vm.menuList}}),_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('sidebar')],1),_c('el-col',{staticStyle:{"padding":"20px"},attrs:{"span":20}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }